import classNames from 'classnames'
import { MdOutlineFlag } from 'react-icons/md'

import type { ReactElement } from 'react'
import type { OptionProps } from 'react-select'

import './styles.scss'

export const formatOptionLabel = ({ label, value }: IOption): ReactElement => {
  const flagClasses = classNames('option-flag-icon fi', { [`fi-${value.toLowerCase()}`]: true })

  return (
    <div className="option-label-custom-format">
      <span className={flagClasses} />
      <div>{label}</div>
    </div>
  )
}

const CustomFlagOption = ({
  className,
  cx,
  data,
  innerProps,
  innerRef,
  isDisabled,
  isFocused,
  isSelected,
}: OptionProps): ReactElement => {
  const { label, value } = data as IOption

  const flagClasses = classNames('option-flag-icon fi', { [`fi-${value.toLowerCase()}`]: true })
  const optionFlagLabelClasses = classNames('option-flag-label', { selected: isSelected })

  return (
    <div
      className={cx(
        {
          option: true,
          'option--is-disabled': isDisabled,
          'option--is-focused': isFocused,
          'option--is-selected': isSelected,
          'option-flag': true,
        },
        className
      )}
      ref={innerRef}
      {...innerProps}
    >
      {value === 'WW' ? <MdOutlineFlag size={24} /> : <span className={flagClasses} />}
      <div className={optionFlagLabelClasses}>{label}</div>
    </div>
  )
}

export default CustomFlagOption
